import { mutator } from 'satcheljs';
import getStore from '../store';
import { SearchScenarioId } from 'owa-search-store';
import { startSearch, searchSessionEnded } from 'owa-search-actions';
import {
    timestreamSearchCompleted,
    invokeTimestreamSearch,
    SearchResultItem,
} from 'owa-timestream-search-orchestration';
import { INITIALIZATION_ACTION_SOURCE } from '../constants';
import { ObservableMap } from 'mobx';
import { onAssetSearchStarted } from 'owa-timestream-asset-search';

// searchInitialized mutators
mutator(startSearch, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().searchInitialized = true;
    }
});

mutator(searchSessionEnded, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces && getStore().searchInitialized) {
        getStore().searchInitialized = false;
    }
});

// loading mutators
mutator(onAssetSearchStarted, actionMessage => {
    getStore().loading += 1;
});

mutator(timestreamSearchCompleted, actionMessage => {
    getStore().loading = Math.max(0, getStore().loading - 1);
});

mutator(searchSessionEnded, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().loading = 0;
    }
});

// searchTerms mutators
mutator(invokeTimestreamSearch, actionMessage => {
    getStore().searchTerms = [];
});

mutator(startSearch, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().searchTerms = [];
    }
});

mutator(timestreamSearchCompleted, actionMessage => {
    // searchTerms comes from substrate search response, but not every asset type's
    // search will have a response for it. if not, default to just splitting the query string
    const searchResponseTerms = actionMessage?.searchResponse?.searchTerms;
    const searchTerms =
        searchResponseTerms && searchResponseTerms.length > 0
            ? searchResponseTerms
            : actionMessage.searchRequest?.queryString.split(/(\s+)/);

    // Setting the search terms
    if (searchTerms && searchTerms.length > 0) {
        getStore().searchTerms.push(...searchTerms);
    }
});

mutator(searchSessionEnded, actionMessage => {
    if (
        actionMessage.scenarioId === SearchScenarioId.Spaces &&
        getStore().searchTerms.length !== 0
    ) {
        getStore().searchTerms = [];
    }
});

// error mutators
mutator(invokeTimestreamSearch, actionMessage => {
    getStore().error = '';
});

mutator(startSearch, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().error = '';
    }
});

mutator(timestreamSearchCompleted, actionMessage => {
    if (actionMessage.error) {
        getStore().error = actionMessage.error;
    }
});

mutator(searchSessionEnded, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().error = '';
    }
});

// searchResults mutators
mutator(invokeTimestreamSearch, actionMessage => {
    getStore().searchResults = new ObservableMap<string, ObservableMap<string, SearchResultItem>>();
});

mutator(startSearch, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Spaces) {
        getStore().searchResults = new ObservableMap<
            string,
            ObservableMap<string, SearchResultItem>
        >();
    }
});

mutator(searchSessionEnded, actionMessage => {
    // only clear results if we're in search mode
    if (actionMessage.scenarioId === SearchScenarioId.Spaces && getStore().searchInitialized) {
        getStore().searchResults = new ObservableMap<
            string,
            ObservableMap<string, SearchResultItem>
        >();
    }
});

mutator(timestreamSearchCompleted, actionMessage => {
    const store = getStore();
    if (!actionMessage.searchResponse) {
        // TODO we'll need to have error handling at some point
        return;
    }

    const { results, assetType } = actionMessage.searchResponse;

    // Setting the search results
    if (results) {
        if (!store.searchResults.get(assetType)) {
            store.searchResults.set(assetType, new ObservableMap<string, SearchResultItem>());
        }
        let existingSearchResults = store.searchResults.get(assetType);
        results.forEach(item => {
            if (!existingSearchResults) {
                store.searchResults;
            }
            if (
                existingSearchResults.has(item.id) &&
                !existingSearchResults
                    .get(item.id)
                    .matchingTerms.includes(actionMessage.searchRequest.queryString)
            ) {
                existingSearchResults
                    .get(item.id)
                    .matchingTerms.push(actionMessage.searchRequest.queryString);
            } else {
                existingSearchResults.set(item.id, item);
            }
        });
    }
});

// isManualSearch mutators
mutator(invokeTimestreamSearch, ({ actionSource }) => {
    getStore().isManualSearch = actionSource !== INITIALIZATION_ACTION_SOURCE;
});
